/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssayEnvelopeArtifactTokenOut } from '../models/AssayEnvelopeArtifactTokenOut';
import type { AssayEnvelopeAvailabilityOut } from '../models/AssayEnvelopeAvailabilityOut';
import type { AssayEnvelopeFileOut } from '../models/AssayEnvelopeFileOut';
import type { AssayEnvelopeGroupOut } from '../models/AssayEnvelopeGroupOut';
import type { AssayEnvelopeLegacyResolutionOut } from '../models/AssayEnvelopeLegacyResolutionOut';
import type { AssayEnvelopeLineageOut } from '../models/AssayEnvelopeLineageOut';
import type { AssayEnvelopeProvenanceRecordOut } from '../models/AssayEnvelopeProvenanceRecordOut';
import type { ExtractionAssignmentOut } from '../models/ExtractionAssignmentOut';
import type { ExtractionAssignmentUpdateIn } from '../models/ExtractionAssignmentUpdateIn';
import type { ExtractionGroupLifecycleOut } from '../models/ExtractionGroupLifecycleOut';
import type { ExtractionGroupRenameIn } from '../models/ExtractionGroupRenameIn';
import type { ExtractionReviewerOut } from '../models/ExtractionReviewerOut';
import type { Paginated_AssayEnvelopeGroupOut_ } from '../models/Paginated_AssayEnvelopeGroupOut_';
import type { SourcePdfUrlOut } from '../models/SourcePdfUrlOut';
import type { WideExtraction } from '../models/WideExtraction';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AssayEnvelopeBrowserService {
    /**
     * Get Availability
     * @returns AssayEnvelopeAvailabilityOut Successful Response
     * @throws ApiError
     */
    public static getAvailabilityProjectsProjectIdAssayEnvelopesAvailabilityGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<AssayEnvelopeAvailabilityOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/availability',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get File
     * @returns AssayEnvelopeFileOut Successful Response
     * @throws ApiError
     */
    public static getFileProjectsProjectIdAssayEnvelopesFilesFileIdGet({
        projectId,
        fileId,
        treeKind = 'assay',
    }: {
        projectId: number,
        fileId: string,
        treeKind?: 'assay' | 'channel',
    }): CancelablePromise<AssayEnvelopeFileOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            query: {
                'tree_kind': treeKind,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Artifact Page
     * @returns AssayEnvelopeArtifactTokenOut Successful Response
     * @throws ApiError
     */
    public static getArtifactPageProjectsProjectIdAssayEnvelopesFilesFileIdArtifactsPageGet({
        projectId,
        fileId,
        page,
    }: {
        projectId: number,
        fileId: string,
        page: number,
    }): CancelablePromise<Array<AssayEnvelopeArtifactTokenOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/artifacts/{page}',
            path: {
                'project_id': projectId,
                'file_id': fileId,
                'page': page,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Wide
     * @returns WideExtraction Verified wide assay extraction.
     * @throws ApiError
     */
    public static getWideProjectsProjectIdAssayEnvelopesFilesFileIdAssayWideGet({
        projectId,
        fileId,
        variant = 'effective',
        ifNoneMatch,
    }: {
        projectId: number,
        fileId: string,
        variant?: 'effective' | 'original',
        ifNoneMatch?: (string | null),
    }): CancelablePromise<WideExtraction> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/assay-wide',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            headers: {
                'If-None-Match': ifNoneMatch,
            },
            query: {
                'variant': variant,
            },
            errors: {
                304: `The cached wide extraction is current.`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Lineage
     * @returns AssayEnvelopeLineageOut Successful Response
     * @throws ApiError
     */
    public static getLineageProjectsProjectIdAssayEnvelopesFilesFileIdLineageGet({
        projectId,
        fileId,
    }: {
        projectId: number,
        fileId: string,
    }): CancelablePromise<AssayEnvelopeLineageOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/lineage',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provenance Page
     * @returns AssayEnvelopeProvenanceRecordOut Successful Response
     * @throws ApiError
     */
    public static getProvenancePageProjectsProjectIdAssayEnvelopesFilesFileIdProvenancePageGet({
        projectId,
        fileId,
        page,
    }: {
        projectId: number,
        fileId: string,
        page: number,
    }): CancelablePromise<Array<AssayEnvelopeProvenanceRecordOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/provenance/{page}',
            path: {
                'project_id': projectId,
                'file_id': fileId,
                'page': page,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Source Pdf
     * @returns binary Source PDF.
     * @throws ApiError
     */
    public static getSourcePdfProjectsProjectIdAssayEnvelopesFilesFileIdSourcePdfGet({
        projectId,
        fileId,
        treeKind = 'assay',
        range,
    }: {
        projectId: number,
        fileId: string,
        treeKind?: 'assay' | 'channel',
        range?: (string | null),
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/source-pdf',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            headers: {
                'Range': range,
            },
            query: {
                'tree_kind': treeKind,
            },
            errors: {
                404: `Source PDF or extraction reference was not found.`,
                409: `Source PDF identity failed integrity verification.`,
                413: `Source PDF exceeds the configured size limit.`,
                416: `Invalid or unsatisfiable byte range.`,
                422: `Source PDF or request is invalid.`,
                503: `Source PDF storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Source Pdf Url
     * @returns SourcePdfUrlOut Successful Response
     * @throws ApiError
     */
    public static getSourcePdfUrlProjectsProjectIdAssayEnvelopesFilesFileIdSourcePdfUrlGet({
        projectId,
        fileId,
        treeKind = 'assay',
    }: {
        projectId: number,
        fileId: string,
        treeKind?: 'assay' | 'channel',
    }): CancelablePromise<SourcePdfUrlOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/files/{file_id}/source-pdf-url',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            query: {
                'tree_kind': treeKind,
            },
            errors: {
                404: `Source PDF or extraction reference was not found.`,
                409: `Source PDF identity failed integrity verification.`,
                413: `Source PDF exceeds the configured size limit.`,
                422: `Source PDF or request is invalid.`,
                503: `Source PDF storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * List Groups
     * @returns Paginated_AssayEnvelopeGroupOut_ Successful Response
     * @throws ApiError
     */
    public static listGroupsProjectsProjectIdAssayEnvelopesGroupsGet({
        projectId,
        treeKind = 'assay',
        assignee = 'all',
        assigneeIds,
        includeUnassigned = false,
        search = '',
        review = 'all',
        sort = '-updated_at',
        page = 1,
        pageSize = 20,
    }: {
        projectId: number,
        treeKind?: 'assay' | 'channel',
        assignee?: 'all' | 'mine' | 'unassigned',
        assigneeIds?: Array<string>,
        includeUnassigned?: boolean,
        search?: string,
        review?: string,
        sort?: string,
        page?: number,
        pageSize?: number,
    }): CancelablePromise<Paginated_AssayEnvelopeGroupOut_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/groups',
            path: {
                'project_id': projectId,
            },
            query: {
                'tree_kind': treeKind,
                'assignee': assignee,
                'assignee_ids': assigneeIds,
                'include_unassigned': includeUnassigned,
                'search': search,
                'review': review,
                'sort': sort,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Group
     * @returns AssayEnvelopeGroupOut Successful Response
     * @throws ApiError
     */
    public static getGroupProjectsProjectIdAssayEnvelopesGroupsScopeIdGet({
        projectId,
        scopeId,
        treeKind = 'assay',
    }: {
        projectId: number,
        scopeId: string,
        treeKind?: 'assay' | 'channel',
    }): CancelablePromise<AssayEnvelopeGroupOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/groups/{scope_id}',
            path: {
                'project_id': projectId,
                'scope_id': scopeId,
            },
            query: {
                'tree_kind': treeKind,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Group Assignment
     * @returns ExtractionAssignmentOut Successful Response
     * @throws ApiError
     */
    public static updateGroupAssignmentProjectsProjectIdAssayEnvelopesGroupsScopeIdAssignmentPut({
        projectId,
        scopeId,
        treeKind,
        requestBody,
    }: {
        projectId: number,
        scopeId: string,
        treeKind: 'assay' | 'channel',
        requestBody: ExtractionAssignmentUpdateIn,
    }): CancelablePromise<ExtractionAssignmentOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/assay-envelopes/groups/{scope_id}/assignment',
            path: {
                'project_id': projectId,
                'scope_id': scopeId,
            },
            query: {
                'tree_kind': treeKind,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication is required.`,
                403: `The actor is not an internal user.`,
                404: `The native extraction group was not found.`,
                409: `The assignment version changed or native extraction state is unavailable.`,
                422: `The assignment target or request is invalid.`,
            },
        });
    }
    /**
     * Delete Group
     * @returns ExtractionGroupLifecycleOut Successful Response
     * @throws ApiError
     */
    public static deleteGroupProjectsProjectIdAssayEnvelopesGroupsScopeIdLifecycleDelete({
        projectId,
        scopeId,
        treeKind,
        expectedVersion,
    }: {
        projectId: number,
        scopeId: string,
        treeKind: 'assay' | 'channel',
        expectedVersion: number,
    }): CancelablePromise<ExtractionGroupLifecycleOut> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/projects/{project_id}/assay-envelopes/groups/{scope_id}/lifecycle',
            path: {
                'project_id': projectId,
                'scope_id': scopeId,
            },
            query: {
                'tree_kind': treeKind,
                'expected_version': expectedVersion,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Group Lifecycle
     * @returns ExtractionGroupLifecycleOut Successful Response
     * @throws ApiError
     */
    public static getGroupLifecycleProjectsProjectIdAssayEnvelopesGroupsScopeIdLifecycleGet({
        projectId,
        scopeId,
        treeKind,
    }: {
        projectId: number,
        scopeId: string,
        treeKind: 'assay' | 'channel',
    }): CancelablePromise<ExtractionGroupLifecycleOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/groups/{scope_id}/lifecycle',
            path: {
                'project_id': projectId,
                'scope_id': scopeId,
            },
            query: {
                'tree_kind': treeKind,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Rename Group
     * @returns ExtractionGroupLifecycleOut Successful Response
     * @throws ApiError
     */
    public static renameGroupProjectsProjectIdAssayEnvelopesGroupsScopeIdLifecyclePatch({
        projectId,
        scopeId,
        treeKind,
        requestBody,
    }: {
        projectId: number,
        scopeId: string,
        treeKind: 'assay' | 'channel',
        requestBody: ExtractionGroupRenameIn,
    }): CancelablePromise<ExtractionGroupLifecycleOut> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/projects/{project_id}/assay-envelopes/groups/{scope_id}/lifecycle',
            path: {
                'project_id': projectId,
                'scope_id': scopeId,
            },
            query: {
                'tree_kind': treeKind,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Restore Group
     * @returns ExtractionGroupLifecycleOut Successful Response
     * @throws ApiError
     */
    public static restoreGroupProjectsProjectIdAssayEnvelopesGroupsScopeIdLifecycleRestorePost({
        projectId,
        scopeId,
        treeKind,
        expectedVersion,
    }: {
        projectId: number,
        scopeId: string,
        treeKind: 'assay' | 'channel',
        expectedVersion: number,
    }): CancelablePromise<ExtractionGroupLifecycleOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/assay-envelopes/groups/{scope_id}/lifecycle/restore',
            path: {
                'project_id': projectId,
                'scope_id': scopeId,
            },
            query: {
                'tree_kind': treeKind,
                'expected_version': expectedVersion,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resolve Legacy
     * @returns AssayEnvelopeLegacyResolutionOut Successful Response
     * @throws ApiError
     */
    public static resolveLegacyProjectsProjectIdAssayEnvelopesResolveLegacyGet({
        projectId,
        extractionId,
        certSlug,
        treeKind,
    }: {
        projectId: number,
        extractionId: string,
        certSlug: string,
        treeKind: 'assay' | 'channel',
    }): CancelablePromise<AssayEnvelopeLegacyResolutionOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/resolve-legacy',
            path: {
                'project_id': projectId,
            },
            query: {
                'extraction_id': extractionId,
                'cert_slug': certSlug,
                'tree_kind': treeKind,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Reviewers
     * @returns ExtractionReviewerOut Successful Response
     * @throws ApiError
     */
    public static listReviewersProjectsProjectIdAssayEnvelopesReviewersGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<Array<ExtractionReviewerOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/assay-envelopes/reviewers',
            path: {
                'project_id': projectId,
            },
            errors: {
                401: `Authentication is required.`,
                403: `Only internal users can view the assignee directory.`,
                422: `Validation Error`,
            },
        });
    }
}
